import { WEEK } from "@mezo/sdk"
import { Duration } from "luxon"

export const msToTimestamp = (ms: number) => ms / 1000

export const convertWeeksToSeconds = (value: number): number =>
  value * msToTimestamp(WEEK)

export const formatDate = (date: Date, withTimePart = true): string => {
  const isoDate = date.toISOString().split(".")[0]

  return withTimePart ? isoDate.replace("T", " ") : isoDate.split("T")[0]
}

export const formatTimestampToDate = (
  timestamp: number,
  withTimePart = false,
): string => formatDate(new Date(timestamp * 1_000), withTimePart)

export const formatDuration = (count: number, format: string) =>
  Duration.fromMillis(count).toFormat(format)

export const formatTimestampToLocaleTime = (timestamp: number): string =>
  new Date(timestamp * 1000).toLocaleTimeString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })
